module.exports = __webpack_public_path__ + "cart.6b0882922e3a545284e6aca85d9d5220.svg";